import { Helmet } from "react-helmet";
import BottomNavigationComponent from "../components/navigation/bottomNavigationComponent";
import ProfileLayout from "../sections/profile/profileLayout";
import WebNavigationComponent from "../components/navigation/webNavigationComponent";

const navOption = 3;

const ProfilePage = () => {
    <Helmet>
        <title>Profile</title>
    </Helmet>

    return(
        <>
            <WebNavigationComponent defaultIndex={navOption}/>

            <ProfileLayout />

            <BottomNavigationComponent defaultIndex={navOption}/>
        </>
    );
}

export default ProfilePage;